/* eslint-disable max-len */
import { ComponentPropsWithoutRef, memo } from 'react';

type HeaderLogoProps = ComponentPropsWithoutRef<'svg'>;

function HeaderLogo({ fill = 'black', ...props }: HeaderLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="163"
      height="27"
      viewBox="0 0 163 27"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3759_32814)">
        <path
          d="M48 9.89844L42 0.898438H32L43 16.8984L34 26.8984H45L66 0.898438H55L48 9.89844Z"
          fill={fill}
        />
        <path
          d="M22 9.89844V10.8984C28.4711 11.6566 31.8198 14.7969 32 20.8984H21C21.107 14.0757 17.2065 13.8984 13 13.8984H10V20.8984H0V0.898438H10V7.89844H13C16.9191 7.89844 20.1083 7.07208 20 0.898438H32C31.8198 5.98771 28.6512 9.21278 22 9.89844Z"
          fill={fill}
        />
        <path
          d="M84 0.898438H67V20.8984H76V5.89844H81C85.5699 5.89844 87 7.60256 87 11.8984V20.8984H96V11.8984C96 4.82265 92.9291 0.898438 84 0.898438Z"
          fill={fill}
        />
        <path
          d="M146 0.898438H132V26.8984H142V20.8984H146C155.713 20.8984 162 16.8878 162 10.8984C162 4.90911 155.462 0.898438 146 0.898438ZM146 15.8984H142V5.89844H146C150.086 5.89844 152 7.70724 152 10.8984C152 13.8033 150.05 15.8984 146 15.8984Z"
          fill={fill}
        />
        <path
          d="M114 0.898438C104.468 0.898438 97 5.87415 97 11.8984C97 17.9227 104.181 21.8984 114 21.8984C121.734 21.8984 129.418 18.88 131 14.8984H121C119.597 16.8016 116.266 17.8984 114 17.8984C110.403 17.8984 107.72 15.8577 107 12.8984H131C131.289 6.1689 124.001 0.898438 114 0.898438ZM107 8.89844C108.188 6.32605 111.193 4.89844 114 4.89844C117.129 4.89844 119.849 6.1852 121 8.89844H107Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3759_32814">
          <rect
            width="163"
            height="26"
            fill="white"
            transform="translate(0 0.898438)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(HeaderLogo);
